import { connect } from "react-redux";

var LoadingButton = require("components/utility/LoadingButton");
var StudentsSelectedDisplay = require("components/org/roster/StudentsSelectedDisplay");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var CurrentUser = require("lib/account/CurrentUser");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

@connect(
	(state, props) => ({
		totalStudents: RosterSelectors.students({ state }).length
	}),
	(dispatch, props) => ({
		createUserAlerts: (userAlert, on) => {
			return dispatch(RosterActions.createUserAlerts({ on, userAlert }))
		}
	})
)
class SendNote extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false
		};
	}

	sendNote(e) {
		$wr.nope(e)
		this.refs.errors.reset();
		var errors = [];

		if (!this.state.loading) {
			this.setState({ loading: true });
			var message = this.refs.note.value;

			if (message == "") {
				errors.push("Please enter a message for your note.");
			}

			if (errors.length == 0) {
				var title = "Note Sent"
				var text = "A carrier pigeon, no, an owl is delivering your note."
				var studentIds = _.pluck(this.props.students, "id");
				var userAlert = {
					message: message, student_ids: studentIds 
				};

				this.props.createUserAlerts(userAlert, "site").then(() => {
					this.setState({ loading: false });
					window.wrNotifications.triggerDropDownNotification({
						title: title, text: text, icon: "ok-circle", duration: 4000 });

						if (this.props.onComplete) {
							this.props.onComplete()
						}
				});
				
			} else {
				this.setState({ loading: false });
				this.refs.errors.setErrors(errors);
			}
		}
	}

	render() {
		var nudgeStudents = window.location.href.includes("nudgeStudents")
		if (nudgeStudents) {
			var placeholderText = "Hey Kiddos, let's get some more quizzes done!"
		} else {
			var placeholderText = "Your message goes here..."
		}

		return (
			<div className="sendNote">
				<StudentsSelectedDisplay totalStudents={ this.props.totalStudents }
					studentsSelected={ this.props.students } />

				<form onSubmit={ this.sendNote } className="sendNoteForm">
					<ErrorDisplay ref="errors" />
					<label>Note:</label>
					<textarea className="form-control noteContent" name="message" rows="3" ref="note"
						placeholder={ placeholderText }></textarea>
					<LoadingButton className="buttonSuccess center-block" text="Send Note" loading={ this.state.loading } />
				</form>
			</div>
		);
	}
};

SendNote.WrappedComponent.propTypes = StrictPropTypes({
	// From above
	students: PropTypes.array,
	onComplete: PropTypes.func,
	
	// Data from @connect
	totalStudents: PropTypes.number,
	
	// Handler from @connect
	createUserAlerts: PropTypes.func
});

module.exports = SendNote;



// WEBPACK FOOTER //
// ./modules/components/org/roster/SendNote.js